
import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { HotelBedCatalogData, HotelBedData } from 'src/shared';
import Tooltip from 'rc-tooltip';
import * as moment from 'moment';
import { FormatterUtils, ModalWrapper } from 'src/core';
import { getAjaxhelper } from 'src/utils';
import { PendedRequestAjaxRechecker } from 'src/utils/PendedRequestAjaxRechecker';
import { ShowRoomDetail } from './ShowRoomDetail';
// import { getAjaxhelper } from 'src/utils';
/**
 * TODO: rate Comment, almoment <10
 */
export interface RoomAvailabilityListDetailProps extends BaseComponentProps {
    roomData?: HotelBedCatalogData.ReqHotelAvailableRateDetail;
    currencyCode: string;
    firebaseApp: firebase.app.App;
    night: string;
    reqKey: string;
    sameWindow?: boolean;
    lang: string;
    history: History | any;
}
export interface RoomAvailabilityListDetailState extends BaseComponentState {
    roomData: HotelBedCatalogData.ReqHotelAvailableRateDetail;
    checkAvailabilitiBtnText: any;
    checkAvailabilitiProcessing: boolean;
    bookingPolicyText: any;
    roomOpen: boolean;
    roomCode: string;
    roomName: string;
}

export class RoomAvailabilityListDetail extends BaseComponent<RoomAvailabilityListDetailProps, RoomAvailabilityListDetailState> {

    constructor(props: RoomAvailabilityListDetailProps) {
        super(props);
        let x: HotelBedCatalogData.ReqHotelAvailableRateDetail // { "id": 5587, "reqAvailableDetailId": 198550, "boardName": "ROOM ONLY", "rateDetail": "{\"DBT.DX-VP\":{\"roomCode\":\"DBT.DX-VP\",\"roomName\":\"Double or Twin DELUXE POOL VIEW\",\"rates\":[{\"rateKey\":\"20190131|20190202|W|325|396019|DBT.DX-VP|NRF-BAR-ALL-RO|RO||1~2~2|4~6|P@51A84202EFA240D1548834703813AAAU0000182000600020122086\",\"rateClass\":\"NRF\",\"rateType\":\"BOOKABLE\",\"net\":161.184,\"allotment\":19,\"paymentType\":\"AT_WEB\",\"packaging\":true,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"cancellationPolicies\":[{\"amount\":161.184,\"from\":\"2019-01-29T23:59:00+07:00\",\"actAmm\":\"134.32\"}],\"rooms\":1,\"adults\":2,\"children\":2,\"childrenAges\":\"4,6\",\"promotions\":[{\"code\":\"073\",\"name\":\"Non-refundable rate. No amendments permitted\"}],\"offers\":[{\"code\":\"9007\",\"name\":\"Last minute discount\",\"amount\":-25.78176,\"actAmm\":-21.4848},{\"code\":\"9001\",\"name\":\"Child discount\",\"amount\":-228.92543999999998,\"actAmm\":-190.7712},{\"code\":\"9005\",\"name\":\"Exclusive discount\",\"amount\":-45.550079999999994,\"actAmm\":-37.9584}],\"actprc\":134.32},{\"rateKey\":\"20190131|20190202|W|325|396019|DBT.DX-VP|NRF-BAR-ALL-RO|RO||1~2~2|8~5|P@51A84202EFA240D1548834703813AAAU0000182000600020122086\",\"rateClass\":\"NRF\",\"rateType\":\"BOOKABLE\",\"net\":161.184,\"allotment\":19,\"paymentType\":\"AT_WEB\",\"packaging\":true,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"cancellationPolicies\":[{\"amount\":161.184,\"from\":\"2019-01-29T23:59:00+07:00\",\"actAmm\":\"134.32\"}],\"rooms\":1,\"adults\":2,\"children\":2,\"childrenAges\":\"8,5\",\"promotions\":[{\"code\":\"073\",\"name\":\"Non-refundable rate. No amendments permitted\"}],\"offers\":[{\"code\":\"9007\",\"name\":\"Last minute discount\",\"amount\":-25.78176,\"actAmm\":-21.4848},{\"code\":\"9001\",\"name\":\"Child discount\",\"amount\":-228.92543999999998,\"actAmm\":-190.7712},{\"code\":\"9005\",\"name\":\"Exclusive discount\",\"amount\":-45.550079999999994,\"actAmm\":-37.9584}],\"actprc\":134.32}]},\"DBT.SU\":{\"roomCode\":\"DBT.SU\",\"roomName\":\"Double or Twin SUPERIOR\",\"rates\":[{\"rateKey\":\"20190131|20190202|W|325|396019|DBT.SU|NRF-BAR-ALL-RO|RO||1~2~1|5|P@51A84202EFA240D1548834703813AAAU0000182000600020123253\",\"rateClass\":\"NRF\",\"rateType\":\"BOOKABLE\",\"net\":100.2,\"allotment\":11,\"paymentType\":\"AT_WEB\",\"packaging\":true,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"cancellationPolicies\":[{\"amount\":100.2,\"from\":\"2019-01-29T23:59:00+07:00\",\"actAmm\":\"83.50\"}],\"rooms\":1,\"adults\":2,\"children\":1,\"childrenAges\":\"5\",\"promotions\":[{\"code\":\"073\",\"name\":\"Non-refundable rate. No amendments permitted\"}],\"offers\":[{\"code\":\"9007\",\"name\":\"Last minute discount\",\"amount\":-13.3344,\"actAmm\":-11.112},{\"code\":\"9005\",\"name\":\"Exclusive discount\",\"amount\":-23.5584,\"actAmm\":-19.631999999999998}],\"actprc\":83.5},{\"rateKey\":\"20190131|20190202|W|325|396019|DBT.SU|NRF-BAR-ALL-RO|RO||1~2~1|12|P@51A84202EFA240D1548834703813AAAU0000182000600020125e63\",\"rateClass\":\"NRF\",\"rateType\":\"BOOKABLE\",\"net\":119.928,\"allotment\":11,\"paymentType\":\"AT_WEB\",\"packaging\":true,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"cancellationPolicies\":[{\"amount\":119.928,\"from\":\"2019-01-29T23:59:00+07:00\",\"actAmm\":\"99.94\"}],\"rooms\":1,\"adults\":2,\"children\":1,\"childrenAges\":\"12\",\"promotions\":[{\"code\":\"073\",\"name\":\"Non-refundable rate. No amendments permitted\"}],\"offers\":[{\"code\":\"9007\",\"name\":\"Last minute discount\",\"amount\":-19.215359999999997,\"actAmm\":-16.0128},{\"code\":\"9001\",\"name\":\"Child discount\",\"amount\":-57.024,\"actAmm\":-47.52},{\"code\":\"9005\",\"name\":\"Exclusive discount\",\"amount\":-33.90336,\"actAmm\":-28.2528}],\"actprc\":99.94},{\"rateKey\":\"20190131|20190202|W|325|396019|DBT.SU|NRF-BAR-ALL-RO|RO||1~2~1|7|P@51A84202EFA240D1548834703813AAAU0000182000600020125e63\",\"rateClass\":\"NRF\",\"rateType\":\"BOOKABLE\",\"net\":119.928,\"allotment\":11,\"paymentType\":\"AT_WEB\",\"packaging\":true,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"cancellationPolicies\":[{\"amount\":119.928,\"from\":\"2019-01-29T23:59:00+07:00\",\"actAmm\":\"99.94\"}],\"rooms\":1,\"adults\":2,\"children\":1,\"childrenAges\":\"7\",\"promotions\":[{\"code\":\"073\",\"name\":\"Non-refundable rate. No amendments permitted\"}],\"offers\":[{\"code\":\"9007\",\"name\":\"Last minute discount\",\"amount\":-19.215359999999997,\"actAmm\":-16.0128},{\"code\":\"9001\",\"name\":\"Child discount\",\"amount\":-57.024,\"actAmm\":-47.52},{\"code\":\"9005\",\"name\":\"Exclusive discount\",\"amount\":-33.90336,\"actAmm\":-28.2528}],\"actprc\":99.94}]}}", "rateType": "BOOKABLE", "currencyCode": "AUD", "discountName": "Child discount", "net": 662.42, "discount": -228.93, "roomName": "2 x Double or Twin DELUXE POOL VIEW, 3 x Double or Twin SUPERIOR", "roomNo": 5, "adults": 10, "children": 7 };
            = { "id": 3307, "reqAvailableDetailId": 220289, "hotelCode": 584543, "boardName": "ROOM ONLY", "rateDetail": "{\"DBL.ST\":{\"roomCode\":\"DBL.ST\",\"roomFullCode\":\"584543.DBL.ST\",\"roomName\":\"DOUBLE STANDARD\",\"jumlah\":4,\"rates\":[{\"rateKey\":\"20190202|20190204|W|325|584543|DBL.ST-1|ID_B2B_24|RO|BP3|1~2~1|5|P@20C5B52FACC546E1549002875654AAAU000037300100002012543c5\",\"rateClass\":\"NRF\",\"rateType\":\"RECHECK\",\"net\":12156000,\"allotment\":8,\"paymentType\":\"AT_WEB\",\"packaging\":true,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"cancellationPolicies\":[{\"amount\":12156000,\"from\":\"2019-02-01T13:34:00+07:00\",\"actAmm\":10130000}],\"rooms\":1,\"adults\":2,\"children\":1,\"childrenAges\":\"5\",\"promotions\":[{\"code\":\"073\",\"name\":\"Non-refundable rate. No amendments permitted\"}],\"actprc\":10130000,\"jumlah\":1},{\"rateKey\":\"20190202|20190204|W|325|584543|DBL.ST-1|ID_B2B_24|RO|BP3|1~2~1|6|P@20C5B52FACC546E1549002875654AAAU000037300100002012543c5\",\"rateClass\":\"NRF\",\"rateType\":\"RECHECK\",\"net\":12156000,\"allotment\":8,\"paymentType\":\"AT_WEB\",\"packaging\":true,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"cancellationPolicies\":[{\"amount\":12156000,\"from\":\"2019-02-01T13:34:00+07:00\",\"actAmm\":10130000}],\"rooms\":1,\"adults\":2,\"children\":1,\"childrenAges\":\"6\",\"promotions\":[{\"code\":\"073\",\"name\":\"Non-refundable rate. No amendments permitted\"}],\"actprc\":10130000,\"jumlah\":1},{\"rateKey\":\"20190202|20190204|W|325|584543|DBL.ST-1|ID_B2B_24|RO|BP3|1~2~0||P@20C5B52FACC546E1549002875654AAAU0000373001000020122665\",\"rateClass\":\"NRF\",\"rateType\":\"RECHECK\",\"net\":1276000,\"allotment\":8,\"paymentType\":\"AT_WEB\",\"packaging\":true,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"cancellationPolicies\":[{\"amount\":1276000,\"from\":\"2019-02-01T13:34:00+07:00\",\"actAmm\":1064000}],\"rooms\":1,\"adults\":2,\"children\":0,\"promotions\":[{\"code\":\"073\",\"name\":\"Non-refundable rate. No amendments permitted\"}],\"actprc\":1064000,\"jumlah\":2}]}}", "rateType": "RECHECK", "currencyCode": "IDR", "discountName": "", "net": 26864000, "discount": 0, "roomName": "4 x DOUBLE STANDARD", "roomNo": 4, "adults": 8, "children": 2 };
        // = { "id": 3342, "reqAvailableDetailId": 220292, "hotelCode": 486242, "boardName": "ROOM ONLY", "rateDetail": "{\"SUI.B1\":{\"roomCode\":\"SUI.B1\",\"roomFullCode\":\"486242.SUI.B1\",\"roomName\":\"SUITE ONE BEDROOM\",\"jumlah\":2,\"rates\":[{\"rateKey\":\"20190202|20190204|W|325|486242|SUI.B1|ID_B2B_26|RO|OD15FF|1~2~1|5|N@20C5B52FACC546E1549002875654AAAU00003730010000201261134\",\"rateClass\":\"NOR\",\"rateType\":\"RECHECK\",\"net\":3889000,\"allotment\":9,\"paymentType\":\"AT_WEB\",\"packaging\":false,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"rooms\":1,\"adults\":2,\"children\":1,\"childrenAges\":\"5\",\"actprc\":3241000,\"jumlah\":1},{\"rateKey\":\"20190202|20190204|W|325|486242|SUI.B1|ID_B2B_26|RO|OD15FF|1~2~1|6|N@20C5B52FACC546E1549002875654AAAU00003730010000201261134\",\"rateClass\":\"NOR\",\"rateType\":\"RECHECK\",\"net\":3889000,\"allotment\":9,\"paymentType\":\"AT_WEB\",\"packaging\":false,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"rooms\":1,\"adults\":2,\"children\":1,\"childrenAges\":\"6\",\"actprc\":3241000,\"jumlah\":1}]},\"TWN.ST\":{\"roomCode\":\"TWN.ST\",\"roomFullCode\":\"486242.TWN.ST\",\"roomName\":\"TWIN STANDARD\",\"jumlah\":2,\"rates\":[{\"rateKey\":\"20190202|20190204|W|325|486242|TWN.ST|ID_B2B_26|RO|OD15FF|1~2~0||N@20C5B52FACC546E1549002875654AAAU0000373001000020125acd\",\"rateClass\":\"NOR\",\"rateType\":\"RECHECK\",\"net\":2592000,\"allotment\":9,\"paymentType\":\"AT_WEB\",\"packaging\":false,\"boardCode\":\"RO\",\"boardName\":\"ROOM ONLY\",\"rooms\":1,\"adults\":2,\"children\":0,\"actprc\":2160000,\"jumlah\":2}]}}", "rateType": "RECHECK", "currencyCode": "IDR", "discountName": "", "net": 12962000, "discount": 0, "roomName": "2 x SUITE ONE BEDROOM, 2 x TWIN STANDARD", "roomNo": 4, "adults": 8, "children": 2 };
        this.state = {
            roomData: props.roomData ? props.roomData : x,
            checkAvailabilitiBtnText: 'I’ll Reserve',
            checkAvailabilitiProcessing: false, bookingPolicyText: null,
            roomOpen: false, roomCode: '', roomName: ''
        };
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let tdBoard: any = <span />;
        let tdPolicy: any[] = [];
        let tdPrice: any[] = [];
        let tdButton: any = <span />;
        let tdOcupution: any = <span />;
        let textPolicy: any[] = [];
        let tglSekarang = new Date();
        let janganUpdateText = false;
        let tmpTanggal = new Date("2100-12-31");
        let checkOneDolar = true;
        let oneDolar = false;
        let mobileDisplay: any[] = [];
        let txtPolicy: any = <span />;
        let tdPriceMobile: any[] = [];
        if (this.state.roomData) {
            let roomData = this.state.roomData;
            tdBoard = <span>{roomData.boardName}</span>;
            if (roomData.discount !== 0) {
                tdPrice.push(
                    <span style={{ color: '#FF0000', textDecorationLine: 'line-through', display: 'block', textAlign: 'center' }}>{new FormatterUtils().formatMoney((roomData.net! - roomData.discount!), this.props.currencyCode, true, false)} </span>
                );
                tdPriceMobile.push(
                    <span style={{ color: '#FF0000', fontSize: '1.2em', textDecorationLine: 'line-through', display: 'block', textAlign: 'center' }}>{new FormatterUtils().formatMoney((roomData.net! - roomData.discount!), this.props.currencyCode, true, false)} </span>
                );
            }
            tdOcupution = <span>For {roomData.roomNo} <i className='fa fa-bed' /> {roomData.adults} <i className='fa fa-user' />  {roomData.children} <i className='fa fa-child' /> </span>;
            tdPrice.push(
                <span style={{ fontWeight: 800, color: "green", display: 'block', fontSize: '1.2em', textAlign: 'center' }}>{new FormatterUtils().formatMoney(roomData.net!, this.props.currencyCode, true, false)}</span>
            );
            tdPriceMobile.push(
                <span style={{ fontWeight: 800, color: "green", display: 'block', fontSize: '1.5em', textAlign: 'center' }}>{new FormatterUtils().formatMoney(roomData.net!, this.props.currencyCode, true, false)}</span>
            );
            let rateDetail: { [roomCode: string]: { roomCode: string, roomFullCode: string, roomName: string, rates: HotelBedData.Rate[], jumlah: number } } = JSON.parse(roomData.rateDetail!);
            let roomPolicyDetail: any[] = []; 

            for (let dtl of Object.keys(rateDetail)) {
                let jumlahKamar = rateDetail[dtl].rates.length;
                for (let rt of rateDetail[dtl].rates) {
                    if (rt.cancellationPolicies && rt.cancellationPolicies.length > 0) {
                        if (!janganUpdateText) {
                            textPolicy = [];
                        }
                        if (jumlahKamar > 1) {
                            roomPolicyDetail.push(
                                <p>For Room {rateDetail[dtl].roomName}</p>
                            );
                        }
                        for (let policy of rt.cancellationPolicies) {
                            // lop++;
                            let dtFrom = new Date(policy.from!);
                            let a = moment(dtFrom);
                            let b = moment(tglSekarang);
                            let jumlahHari = moment.duration(a.diff(b)).as("day");

                            if (dtFrom < tmpTanggal) {
                                tmpTanggal = dtFrom;
                            }
                            let jumlah = rt.jumlah!;
                            if (jumlahHari >= 21) {
                                if (!janganUpdateText) {
                                    if (dtFrom < tmpTanggal || textPolicy.length === 0) {
                                        textPolicy.push(
                                            <span>{`Free Cancellation Before ${dtFrom.getDate()}-${dtFrom.getMonth() + 1}-${dtFrom.getFullYear()}`}</span>
                                        );
                                        textPolicy.push(
                                            <br />
                                        );
                                        textPolicy.push(
                                            <span style={{color: "#ff0000"}}>Book This Room For $1 Deposit - Free Cancellation - Don't Miss Out!</span>
                                        );
                                    }
                                    if (checkOneDolar) {
                                        oneDolar = true;
                                    }
                                }
                            } else {
                                checkOneDolar = false;
                                oneDolar = false;
                                if (!janganUpdateText) {
                                    textPolicy = [];
                                    if (jumlahHari < 2) {
                                        janganUpdateText = true;
                                        textPolicy.push(<p>Non Refunable</p>);
                                    } else {
                                        janganUpdateText = true;
                                        textPolicy.push(<span>{`Free Cancellation Before ${dtFrom.getDate()}-${dtFrom.getMonth() + 1}-${dtFrom.getFullYear()}`}</span>);
                                    }

                                }
                            }

                            roomPolicyDetail.push(
                                <p>Cancelation Fee From  {`${dtFrom.getDate()}-${dtFrom.getMonth() + 1}-${dtFrom.getFullYear()}`} -  {new FormatterUtils().formatMoney((policy.amount as any / 1 * jumlah), this.props.currencyCode, true, false)} </p>
                            );
                        }
                    } else {
                        if (jumlahKamar > 1) {
                            roomPolicyDetail.push(
                                <p>For Room {rateDetail[dtl].roomName}</p>
                            );
                        }
                        checkOneDolar = false;
                        oneDolar = false;
                        if (!janganUpdateText) {
                            textPolicy = [];
                            janganUpdateText = true;
                            textPolicy.push(<p>Please Click Check I'll Reserve Button for Booking Option</p>);
                        }
                        roomPolicyDetail.push(
                            <p>Please Click Check I'll Reserve Button for Booking Option</p>
                        );
                    }

                }

            }
            tdPolicy = roomPolicyDetail;
            tdButton = this.bookingButton(oneDolar);
            txtPolicy = (
                <Tooltip
                    placement='top'
                    overlay={<div >    {tdPolicy} </div>}
                >
                    <div>{textPolicy}</div>
                </Tooltip>
            );
            if (this.state.bookingPolicyText) {
                txtPolicy = this.state.bookingPolicyText;
            } 
            let tdOcupMobile = <span>For  {roomData.adults} <i className='fa fa-user' />  {roomData.children} <i className='fa fa-child' /> </span>;
            mobileDisplay.push(
                <div  className="row col-md-12" >   {tdOcupMobile} ({this.props.night} Night)  <br /></div>
            ); 
            mobileDisplay.push(<div style={{display: 'block', marginTop: 10}}> {txtPolicy} </div>);  
            mobileDisplay.push(
                <div className="row margin-top-10">
                <div className="col-xs-12" style={{textAlign: 'right'}}>({tdBoard})<br/>{tdPriceMobile}</div>
                    <div className="col-xs-12">
                        {tdButton}
                    </div>
                    
                </div> 
            );  
        }
        let style2: ReactModal.Styles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0, 0.75)',
                zIndex: 9999
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                overflow: 'hidden',
                backgroundColor: '#fff',
                border: 0
            }
        };
        return (
            <tr>
                <td className="desktop-only">
                    <div>{tdBoard} <br /> {tdOcupution}</div>
                </td>
                <td className="desktop-only"> {txtPolicy} </td>
                <td className="desktop-only">{tdPrice}</td>
                <td className="desktop-only">{tdButton}</td>
                <td className='mobile-only'>{mobileDisplay}</td>
                <ModalWrapper
                    style={style2}
                    isOpen={this.state.roomOpen}
                    onRequestClose={this.hendlerRoomDetailClose}
                    role="dialog"
                    contentLabel="Minimal Modal Example"
                ><div className="show-room-detail">
                        <ShowRoomDetail roomId={this.state.roomCode} roomName={this.state.roomName} hendlerRoomDetailClose={this.hendlerRoomDetailClose} lang={this.props.lang}/>
                    </div>
                </ModalWrapper>
            </tr>
        );
    }

    hendlerRoomDetailClose: () => any = () => {
        this.setState({ roomOpen: false });
    }

    bookingButton(oneDolar: boolean) {
        let target = '';
        /*
        if (this.props.sameWindow) {
            target = '';
        }
        */
        if (oneDolar) {
            return (
                <div className="btn-group" style={{ width: '100%' }}>
                    <a href="javascript:void(0)" style={{ width: '100%' }} data-toggle="dropdown" className="btn btn-primary dropdown-toggle" aria-expanded="true">
                    $1 Deposit Only! <span className="caret" />
                    </a>
                    <ul className="dropdown-menu" role="menu">
                        <li role="presentation" className="dropdown-header">
                            Book Now Pay Later
                        </li>
                        <li>
                            <a
                                // href={`/booking?rk=${this.props.reqKey}&bn=0&id=${this.state.roomData.id}`}
                                target={target}
                                style={{fontWeight: 800}}
                                onClick={
                                    () => {
                                        // this.props.history.pushState()
                                        this.props.history.push(`/booking?rk=${this.props.reqKey}&bn=0&id=${this.state.roomData.id}`);
                                    }
                                }
                            > Reserve & Pay Later <br /> Free Cancelation
                            </a>
                        </li>
                        <li className="divider" />
                        <li role="presentation" className="dropdown-header">
                            Checkout For Full Payment
                        </li>
                        <li>
                            <a
                                // href={`/booking?rk=${this.props.reqKey}&bn=1&id=${this.state.roomData.id}`}
                                target={target}
                                style={{fontWeight: 800}}
                                onClick={
                                    () => {
                                        // this.props.history.pushState()
                                        this.props.history.push(`/booking?rk=${this.props.reqKey}&bn=1&id=${this.state.roomData.id}`);
                                    }
                                }
                            >Book & Pay Now
                            </a>
                        </li>
                    </ul>
                </div>
            );
        } else {
            let roomData = this.state.roomData;
            if (roomData.rateType === 'RECHECK') {
                return (
                    <button
                        className="btn btn-primary form-control"
                        type='button'
                        onClick={
                            () => {
                                this.checkAvailability(roomData);
                            }
                        }
                    > {this.state.checkAvailabilitiBtnText}
                    </button>
                );
            } else if (roomData.rateType === 'NOTAVAILABLE') {
                return <span className="form-control btn btn-warning"> Room Not Available</span>;
            } else {
                return (
                    <a
                        href={`/booking?rk=${this.props.reqKey}&bn=1&id=${this.state.roomData.id}`}
                        target={target}
                        className="btn btn-primary form-control"
                    >Book Now
                    </a>
                );
                // <input className="btn btn-primary form-control" type='button' value={`Book Now`} />;
            }
        }
    }

    checkAvailability(roomData: HotelBedCatalogData.ReqHotelAvailableRateDetail) {
        let roomDataId = roomData.id;
        this.setStateHelper(
            st => {
                st.checkAvailabilitiProcessing = true;
                st.checkAvailabilitiBtnText = <span> <i className="fa fa-spinner fa-spin" /> Please Wait</span>;
            },
            () => {
                console.log(roomDataId);
                this.finalCheckRate(roomData).then(
                    d => {
                        console.log(d);
                    }
                ).catch(exc => {
                    console.log(exc);
                });
                // getAjaxhelper() 
            }
        );
    }

    finalCheckRate(roomData: HotelBedCatalogData.ReqHotelAvailableRateDetail): Promise<any> {
        return new Promise<any>(async (accept: (n: any) => any, reject: (exc: any) => any) => {
            try {
                let rateKeys: any[] = [];
                let status: 'NOTAVAILABLE' | 'COMPLATE' = "COMPLATE";
                let rateDetail: { [roomCode: string]: { roomCode: string, roomFullCode: string, roomName: string, rates: HotelBedData.Rate[] } } = JSON.parse(roomData.rateDetail!);
                for (let rCode of Object.keys(rateDetail)) {
                    for (let rate of rateDetail[rCode].rates) {
                        if (rate.rateType === 'RECHECK') {
                            rateKeys.push({ rateKey: rate.rateKey });
                        }

                    }
                }
                let saveData = {
                    request: {
                        rooms: rateKeys // request,
                    },
                    currencyCode: this.props.currencyCode,
                    id: roomData.id
                };

                let ajaxHelper = getAjaxhelper();
                try {
                    let data = await new PendedRequestAjaxRechecker(ajaxHelper, this.props.firebaseApp, { maxRecheckTime: 1000, rechecDurationSecond: 3 })
                        .runPendedResultAjaxRequest('post', '/dynamics/hb-api/check-rate', saveData);
                    console.log(data);
                    this.setStateHelper(
                        st => {
                            // st.roomData.rateType = 'AVAILABLE';
                            st.roomData = data;
                            st.checkAvailabilitiProcessing = false;
                        },
                        () => {
                            accept({ status });
                        }
                    );

                } catch (err) {
                    console.log("Error Checkrate", err);
                    status = "NOTAVAILABLE";
                    this.setStateHelper(
                        st => {
                            st.roomData.rateType = 'NOTAVAILABLE';
                            st.checkAvailabilitiProcessing = false;
                            st.bookingPolicyText = <span style={{ color: '#FF0000' }}> <strong>You missed this deal <i className="ti-face-sad" /></strong><br /> These dates are really popular in Bali! </span>;
                        },
                        () => {
                            accept({ status });
                        }
                    );
                }

            } catch (exc) {
                reject(exc);
            }

        });
    }
}



// WEBPACK FOOTER //
// ./src/hotels/RoomAvailabilityListDetail.tsx